module.exports = __webpack_public_path__ + "img/users.12b1726a.svg";